import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { LocalizedName } from 'store/railsBuilder/reducer.types';
import { selectLanguage } from 'store/user/selectors';

function useLocalizedPersonName() {
    const currentLanguage = useSelector(selectLanguage);

    const getLocalizedPersonName = useCallback(
        (names: LocalizedName[]) => {
            const localizedName = names.find((name) =>
                name.locale.includes(currentLanguage),
            );

            if (localizedName) {
                return localizedName.name;
            }

            return names[0].name;
        },
        [currentLanguage],
    );

    return { getLocalizedPersonName };
}

export default useLocalizedPersonName;
